module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/components/narrow-col-timer/narrow-col-timer.component.scss
// module id = ./src/app/modules/boxoffice-module/components/narrow-col-timer/narrow-col-timer.component.scss
// module chunks = 9